import { Navigate } from "react-router-dom";

import { DefaultLayout, LayoutWithHeader } from "core/layouts";
import Dashboard from "pages/dashboard";
import LiveProperties from 'pages/property/live';
import Approvals from "pages/property/approvals/";
import Coupons from "pages/coupons";
import Passes from "pages/passes";
import Enquiries from "pages/enquiries";
import Privacy from "pages/privacy";
import TermsOfUse from "pages/terms";
import AboutUs from "pages/about-us";
import BookingsPage from "pages/bookings";
import SeatLayout from "pages/seat-layout";
import AddLisitng from "pages/property/add-listing";
import earnings from "pages/earnings";
import weSecure from "pages/we-secure";
import GuestReviews from "pages/guest-reviews";
import BookingsReport from "pages/reports/booking";
import IncentiveReport from "pages/reports/incentive";
import PayoutReport from "pages/reports/payout";
import DynamicPricing from "pages/operations/dynamic-pricing";
import SeatSharing from "pages/operations/revenue-sharing/seat-sharing";
import RevenueSharing from "pages/operations/revenue-sharing";
import complaints from "../pages/complaints";
import EnquiryReport from "pages/reports/enquiry";
import Referral from "pages/referral";
import Support from "pages/support";
import Feedback from "pages/feedback";
import Expenses from "pages/expenses";
import Dues from "pages/dues";
import SeatAvailability from "pages/seat-availability";

const AppRoutes = [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Navigate to="/overview/" replace={true} />
  },
  {
    path: "/termsofuse",
    exact: true,
    layout: LayoutWithHeader,
    component: TermsOfUse
  },
  {
    path: "/privacy",
    exact: true,
    layout: LayoutWithHeader,
    component: Privacy
  },
  {
    path: "/about-us",
    exact: true,
    layout: LayoutWithHeader,
    component: AboutUs
  },
  {
    path: "/overview",
    layout: DefaultLayout,
    component: Dashboard,
    enableAuth: true,
  },
  {
    path: "/property/live/",
    layout: DefaultLayout,
    component: LiveProperties,
    enableAuth: true,
  },
  {
    path: "/property/approvals/",
    layout: DefaultLayout,
    component: Approvals,
    enableAuth: true,
  },
  {
    path: "/coupons/",
    layout: DefaultLayout,
    component: Coupons,
    enableAuth: true,
  },
  {
    path: "/passes/",
    layout: DefaultLayout,
    component: Passes,
    enableAuth: true,
  },
  {
    path: "/bookings/",
    layout: DefaultLayout,
    component: BookingsPage,
    enableAuth: true,
  },
  {
    path: "/property/seat-layout/:libraryId",
    layout: DefaultLayout,
    component: SeatLayout,
    enableAuth: true,
  },
  {
    path: "/enquiries/",
    layout: DefaultLayout,
    component: Enquiries,
    enableAuth: true,
  },
  {
    path: "/property-listing/",
    layout: LayoutWithHeader,
    component: AddLisitng,
  },
  {
    path: "/earnings/",
    layout: DefaultLayout,
    component: earnings,
    enableAuth: true,
  },
  {
    path: "/we-secure/",
    layout: DefaultLayout,
    component: weSecure,
    enableAuth: true,
  },
  {
    path: "/guest-reviews/",
    layout: DefaultLayout,
    component: GuestReviews,
    enableAuth: true,
  },
  {
    path: "/reports/booking/",
    layout: DefaultLayout,
    component: BookingsReport,
    enableAuth: true,
  },
  {
    path: "/reports/incentive/",
    layout: DefaultLayout,
    component: IncentiveReport,
    enableAuth: true,
  },
  {
    path: "/reports/payout/",
    layout: DefaultLayout,
    component: PayoutReport,
    enableAuth: true,
  },
  {
    path: "/reports/enquiry/",
    layout: DefaultLayout,
    component: EnquiryReport,
    enableAuth: true,
  },
  {
    path: "/operations/dynamic-pricing/",
    layout: DefaultLayout,
    component: DynamicPricing,
    enableAuth: true,
  },
  {
    path: "/operations/revenue-sharing/",
    layout: DefaultLayout,
    component: RevenueSharing,
    enableAuth: true,
  },
  {
    path: "/operations/revenue-sharing/seat-sharing/",
    layout: DefaultLayout,
    component: SeatSharing,
    enableAuth: true,
  },
  {
    path: "/complaints/",
    layout: DefaultLayout,
    component: complaints,
    enableAuth: true,
  },
  {
    path: "/refer-earn/",
    layout: DefaultLayout,
    component: Referral,
    enableAuth: true,
  },
  {
    path: "/support/",
    layout: DefaultLayout,
    component: Support,
    enableAuth: true,
  },
  {
    path: "/feedback/",
    layout: DefaultLayout,
    component: Feedback,
    enableAuth: true,
  },
  {
    path: "/expenses/",
    layout: DefaultLayout,
    component: Expenses,
    enableAuth: true,
  },
  {
    path: "/dues/",
    layout: DefaultLayout,
    component: Dues,
    enableAuth: true,
  },
  {
    path: "property/seat-availability/:libraryId",
    layout: DefaultLayout,
    component: SeatAvailability,
    enableAuth: true,
  },
  // {
  //   path: "/user/edit/:userId",
  //   layout: DefaultLayout,
  //   component: AddUser,
  //   enableAuth: true,
  //   roles: ['admin', 'manager', 'employee']
  // },
  // {
  //   path: "/pg/search/",
  //   layout: DefaultLayout,
  //   component: SearchPG,
  //   enableAuth: true,
  //   roles: ['admin', 'manager', 'employee']
  // },
  // {
  //   path: "/pg/add/",
  //   layout: DefaultLayout,
  //   component: CreatePG,
  //   enableAuth: true,
  //   roles: ['admin', 'manager', 'employee']
  // },
  // {
  //   path: "/pg/edit/:pgId",
  //   layout: DefaultLayout,
  //   component: AddPG,
  //   enableAuth: true,
  //   roles: ['admin', 'manager', 'employee']
  // },
  // {
  //   path: "/pg/license/renew/:pgId/:userId",
  //   layout: DefaultLayout,
  //   component: UpdatePgLicense,
  //   enableAuth: true,
  //   roles: ['admin', 'manager', 'employee']
  // },
];
export default AppRoutes;
